import request from '@/plugins/request'

export function getShowBizList(key, pageindex, pagesize, orderType) {
    return request({
        url: '/v1/ShowBiz/GetShowBizList',
        method: 'post',
        data: {
            skey: key,
            pageIndex: pageindex,
            pageSize: pagesize,
            orderType: orderType
        }
    })
}

export function showBizeEdit(Id, keyword, wcikeyword, tkkeyword, state) {
    return request({
        url: '/v1/ShowBiz/ShowBizEdit',
        method: 'post',
        data: {
            id: Id,
            keyword: keyword,
            wciKeyWord: wcikeyword,
            tkKeyWord: tkkeyword,
            state: state
        }
    })
}

export function showBizDel(Id) {
    return request({
        url: '/v1/ShowBiz/ShowBizDel',
        method: 'post',
        data: {
            id: Id,
        }
    })
}


export function getUserIndexUrls(Id) {
    return request({
        url: '/v1/ShowBiz/GetUserIndexUrls',
        method: 'post',
        data: {
            id: Id,
        }
    })
}

export function setUserIndexUrls(Id, urls) {
    return request({
        url: '/v1/ShowBiz/SetUserIndexUrls',
        method: 'post',
        data: {
            keyId: Id,
            IndexUrls: urls
        }
    })
}

export function getShowBizVideoList(Id, skey, pageindex, pagesize) {
    return request({
        url: '/v1/ShowBiz/GetShowBizVideoList',
        method: 'post',
        data: {
            keyId: Id,
            skey: skey,
            pageIndex: pageindex,
            pageSize: pagesize
        }
    })
}

export function publishDoubaoTask(ids) {
    return request({
        url: '/v1/ShowBiz/PublishDoubaoTask',
        method: 'post',
        data: {
            ids: ids
        }
    })
}
